import { BridgeEventCallbackName } from '@/api/nativeCallBack';
import { useEffect, useRef } from 'react';

export default function useBridgeEventEffect(
  name: BridgeEventCallbackName,
  callback: (event: CustomEvent) => void,
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handler = (event: Event) => {
      callbackRef.current(event as CustomEvent);
    };

    window.addEventListener(name, handler);
    return () => window.removeEventListener(name, handler);
  }, [name]);
}
